import { getTermValue, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { WINDOWS_TYPE_MAP_VALUE_TO_LABEL } from './constants';
import { EWindowsType } from '../../../../api-models/common/json_query';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'windowsType' as const;

export const windowsTypeTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const windowsType = getTermValue('windows_type')(jsonQuery);

    if (windowsType === null || windowsType === EWindowsType.Any) {
      return null;
    }

    const label = `Окна ${WINDOWS_TYPE_MAP_VALUE_TO_LABEL[windowsType]}`;

    return [{ label, value: createTagValue(ID) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['windows_type'])(jsonQuery),
};
